import { createAsyncThunk } from '@reduxjs/toolkit';
import { softDeleteAndGetLatestOrCreateNew } from '../api/threadsApi';
import { convertCopilotV2ThreadToCopilotV1ThreadForRedux } from '../slices/copilotV2ResponseConversions';
export const copilotV2SoftDeleteAndGetLatestOrCreateNew = createAsyncThunk('threads/copilotV2SoftDeleteAndGetLatestOrCreateNew', async (args, {
  rejectWithValue
}) => {
  try {
    const response = await softDeleteAndGetLatestOrCreateNew(args);
    const {
      thread,
      messages,
      hasMore,
      messageOffset
    } = response;

    // This is still getting converted because we are updating the threads redux state
    const convertedThread = convertCopilotV2ThreadToCopilotV1ThreadForRedux(thread);
    return {
      thread: convertedThread,
      messages,
      hasMore,
      messageOffset
    };
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : `Failed to delete thread ${args.threadIdToDelete} and get latest or create new`);
  }
});